import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MoverRbacRoleEntity } from './mover-rbac-role.entity';

@Entity('_mover_module')
export class MoverModuleEntity extends BaseEntity {
	@Column('varchar', { name: '_key', length: 255 })
	public key!: string;

	@Column('varchar', { name: '_label', length: 64 })
	public label!: string;

	@OneToMany(
		() => MoverRbacRoleEntity,
		(moverRbacRole) => moverRbacRole.fkMoverModule,
		{},
	)
	public moverRbacRoles!: Array<MoverRbacRoleEntity>;
}
